import { reviewGroup, sameLeafLabels } from "./reviewGroups";
import type { RowInput } from "./reviewRow.types";

export function saveAllCounts(
  actionableRows: RowInput[],
  queuedIds: ReadonlySet<string>,
): { blockers: number; ready: number; hidden: number } {
  const counts = { blockers: 0, ready: 0, hidden: 0 };
  const shared = new Set(sameLeafLabels(actionableRows).keys());
  for (const row of actionableRows) {
    const group = reviewGroup(row, queuedIds, shared);
    if (group === "ready" || group === "hidden") counts[group] += 1;
    else counts.blockers += 1;
  }
  return counts;
}

export function saveAllConfirmText(ready: number, hidden: number): string {
  const parts = [
    ready > 0 && `${ready} pre-filled field${ready === 1 ? "" : "s"}`,
    hidden > 0 && `${hidden} field${hidden === 1 ? "" : "s"} hidden by AI`,
  ].filter(Boolean);
  return parts.length ? ` Confirms ${parts.join(" and ")}.` : "";
}
